import { BubblehousePointsRounding } from "@redotech/congo-enums/bubblehouse-points-rounding";
import * as z from "zod";

export const getBubblehouseIntegration = {
  name: "getBubblehouseIntegration" as const,
  input: z.object({}),
  output: z.object({
    bubblehouseIntegration: z
      .object({
        enabled: z.boolean(),
        shopSlug: z.string(),
        keyId: z.string(),
        hasSharedSecret: z.boolean(),
        pointsPerDollar: z.number(),
        pointsRounding: z.enum(BubblehousePointsRounding),
      })
      .optional(),
  }),
};

export type GetBubblehouseIntegrationOutput = z.infer<
  typeof getBubblehouseIntegration.output
>;
